import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export const blocksHeaderWrapper = css`
  margin: 0 0 ${spacing.xs}px;
  border-radius: ${pxToRem(10)};
  width: 100%;
  background: var(--neutral-white-base);
  text-align: left;
  transition: border-color 0.15s ease-in, background-color 0.15s ease-in;
  position: relative;
  color: var(--neutral-black-base);
  font-family: ${fonts.PRIMARY_REGULAR.family};
  ${theme.responsiveText.BODY.XS};
`;
